"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_exports = {};
__export(index_exports, {
  ErrorBoundary: () => import_ErrorBoundary.ErrorBoundary,
  Head: () => import_head.Head,
  Link: () => import_Link.Link,
  LoadProgressBar: () => import_LoadProgressBar.LoadProgressBar,
  NamedSlot: () => import_Navigator.NamedSlot,
  Navigator: () => import_Navigator2.Navigator,
  ParamValidationError: () => import_validateParams.ParamValidationError,
  Presentations: () => import_Presentations.Presentations,
  Protected: () => import_Protected.Protected,
  Redirect: () => import_Redirect.Redirect,
  Root: () => import_Root.Root,
  RouteValidationError: () => import_validateParams.RouteValidationError,
  SafeAreaView: () => import_react_native_safe_area_context.SafeAreaView,
  ScrollBehavior: () => import_ScrollBehavior.ScrollBehavior,
  Slot: () => import_Navigator2.Slot,
  SourceInspector: () => import_SourceInspector.SourceInspector,
  Stack: () => import_Stack.Stack,
  Tabs: () => import_Tabs.Tabs,
  closeIntercept: () => import_interceptRoutes.closeIntercept,
  createAPIRoute: () => import_createAPIRoute.createAPIRoute,
  createApp: () => import_createApp.createApp,
  createMiddleware: () => import_createMiddleware.createMiddleware,
  createRoute: () => import_createRoute.createRoute,
  getLinking: () => import_getLinking.getLinking,
  getLoaderTimingHistory: () => import_useLoader.getLoaderTimingHistory,
  getServerData: () => import_one_server_only.getServerData,
  getURL: () => import_getURL.getURL,
  handleSkewError: () => import_dynamicImport.handleSkewError,
  href: () => import_href.href,
  isChunkLoadError: () => import_dynamicImport.isChunkLoadError,
  isInterceptedNavigation: () => import_interceptRoutes.isInterceptedNavigation,
  isResponse: () => import_isResponse.isResponse,
  lazyWithRetry: () => import_lazyWithRetry.lazyWithRetry,
  loadWithRetry: () => import_dynamicImport.loadWithRetry,
  onClientLoaderResolve: () => import_clientLoaderResolver.onClientLoaderResolve,
  redirect: () => import_redirect.redirect,
  refetchLoader: () => import_useLoader.refetchLoader,
  registerPreloadedRoute: () => import_useViteRoutes.registerPreloadedRoute,
  removeParams: () => import_removeParams.removeParams,
  render: () => import_render.render,
  route: () => import_createRoute.route,
  router: () => import_imperative_api.router,
  routerStore: () => _routerStore,
  setClientMatches: () => import_useMatches.setClientMatches,
  setResponseHeaders: () => import_one_server_only.setResponseHeaders,
  setServerData: () => import_one_server_only.setServerData,
  useActiveParams: () => import_hooks.useActiveParams,
  useBlocker: () => import_useBlocker.useBlocker,
  useDrawer: () => import_useDrawer.useDrawer,
  useFocusEffect: () => import_useFocusEffect.useFocusEffect,
  useGlobalSearchParams: () => import_hooks.useGlobalSearchParams,
  useIsFocused: () => import_core.useIsFocused,
  useLinkTo: () => import_useLinkTo.useLinkTo,
  useLoader: () => import_useLoader.useLoader,
  useLoaderState: () => import_useLoader.useLoaderState,
  useLocalSearchParams: () => import_hooks.useLocalSearchParams,
  useMatch: () => import_useMatches.useMatch,
  useMatches: () => import_useMatches.useMatches,
  useNavigation: () => import_useNavigation.useNavigation,
  useNavigationContainerRef: () => import_hooks.useNavigationContainerRef,
  usePageMatch: () => import_useMatches.usePageMatch,
  useParams: () => import_hooks.useParams,
  usePathname: () => import_hooks.usePathname,
  useRootNavigationState: () => import_hooks.useRootNavigationState,
  useRouter: () => import_hooks.useRouter,
  useSafeAreaInsets: () => import_react_native_safe_area_context.useSafeAreaInsets,
  useScrollGroup: () => import_useScrollGroup.useScrollGroup,
  useSearchParams: () => import_hooks.useSearchParams,
  useSegments: () => import_hooks.useSegments,
  useServerHeadInsertion: () => import_useServerHeadInsertion.useServerHeadInsertion,
  useSitemap: () => import_sitemap.useSitemap,
  useStack: () => import_useStack.useStack,
  useTabs: () => import_useTabs.useTabs,
  useUnstableGlobalHref: () => import_hooks.useUnstableGlobalHref,
  useValidationState: () => import_router.useValidationState,
  validateParams: () => import_validateParams.validateParams,
  watchFile: () => import_watchFile.watchFile,
  withLayoutContext: () => import_withLayoutContext.withLayoutContext,
  zodParamValidator: () => import_validateParams.zodParamValidator
});
module.exports = __toCommonJS(index_exports);
var import_createApp = require("./createApp");
var import_core = require("@react-navigation/core");
__reExport(index_exports, require("@vxrn/color-scheme"), module.exports);
var import_react_native_safe_area_context = require("react-native-safe-area-context");
var import_clientLoaderResolver = require("./clientLoaderResolver");
var import_createMiddleware = require("./createMiddleware");
var import_createAPIRoute = require("./createAPIRoute");
var import_getURL = require("./getURL");
var import_head = require("./head");
var import_hooks = require("./hooks");
var import_href = require("./href");
var import_getLinking = require("./link/getLinking");
var import_sitemap = require("./router/sitemap");
var import_Presentations = require("./headless/Presentations");
var import_useStack = require("./headless/useStack");
var import_Stack = require("./layouts/Stack");
var import_Tabs = require("./layouts/Tabs");
var import_Protected = require("./views/Protected");
var import_useTabs = require("./headless/useTabs");
var import_useDrawer = require("./headless/useDrawer");
var import_withLayoutContext = require("./layouts/withLayoutContext");
var import_Link = require("./link/Link");
var import_Redirect = require("./link/Redirect");
var import_useLinkTo = require("./link/useLinkTo");
var import_Root = require("./Root");
var import_render = require("./render");
var import_createRoute = require("./router/createRoute");
var import_interceptRoutes = require("./router/interceptRoutes");
var import_Navigator = require("./views/Navigator");
var import_imperative_api = require("./router/imperative-api");
var _routerStore = __toESM(require("./router/router"), 1);
var import_useNavigation = require("./router/useNavigation");
var import_useViteRoutes = require("./router/useViteRoutes");
var import_useBlocker = require("./useBlocker");
var import_validateParams = require("./validateParams");
var import_router = require("./router/router");
var import_useFocusEffect = require("./useFocusEffect");
var import_useLoader = require("./useLoader");
var import_useMatches = require("./useMatches");
var import_useServerHeadInsertion = require("./useServerHeadInsertion");
var import_isResponse = require("./utils/isResponse");
var import_redirect = require("./utils/redirect");
var import_removeParams = require("./utils/removeParams");
var import_watchFile = require("./utils/watchFile");
var import_lazyWithRetry = require("./lazyWithRetry");
var import_dynamicImport = require("./utils/dynamicImport");
var import_ErrorBoundary = require("./views/ErrorBoundary");
var import_LoadProgressBar = require("./views/LoadProgressBar");
var import_Navigator2 = require("./views/Navigator");
var import_ScrollBehavior = require("./views/ScrollBehavior");
var import_SourceInspector = require("./views/SourceInspector");
var import_useScrollGroup = require("./useScrollGroup");
var import_one_server_only = require("./vite/one-server-only");
//# sourceMappingURL=index.js.map
